module.exports = "\n<menu></menu>"


//////////////////
// WEBPACK FOOTER
// /home/xpro/Documentos/ances/myjangular/src/app/layout/layout.component.html
// module id = ../../../../../src/app/layout/layout.component.html
// module chunks = main